module.exports = __webpack_public_path__ + "img/5.9e129db1.jpg";